import Modal from '@mui/material/Modal';
import styled from '@emotion/styled/macro';
import { commonStyle, Compose } from 'components/common/CommonStyled';

export const StyledModal = commonStyle(Modal);

export const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: calc(100% - 50px);
  width: 450px;
  background-color: ${({ theme }) => theme.colors.primaryColor};
  box-shadow: ${({ theme }) => theme.shadows[25]};
  padding: 20px;
  border-radius: 8px;

  ${Compose}
`;
